<button (click)="onAsk()" [disabled]="isDisabled">
  <em *ngIf="isDisabled" class="icon-locked"></em>
  <span *ngIf="authors?.length > 0; else askAnExpertTpl">Ask the Author</span>
</button>
<ng-template #askAnExpertTpl>Ask an Expert</ng-template>
